import React from 'react';
import styles from './HowItWorksFooter.module.css';

export const HowItWorksFooter: React.FC = () => {
  return (
    <div className={styles.card}>
      <p className={styles.title}>✨ How AI Insights Work</p>
      <p className={styles.body}>
        Our AI analyzes historical data, customer behavior patterns, seasonal trends, and
        market dynamics to provide personalized recommendations. Confidence scores indicate
        prediction accuracy based on available data.
      </p>
    </div>
  );
};
